import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import TimelineRoundedIcon from '@mui/icons-material/TimelineRounded';
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Divider,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@mui/material';
import React from 'react';

// * i18n
import { useTranslation } from 'react-i18next';

export default function InitiativeActionCell({
  row,
  onView,
  onEdit,
  onDelete,
  onResetDates,
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const { t } = useTranslation('energyxplorer-initiatives-tab');

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleMenuItemClick = (option) => {
    setOpen(false);
    if (option === 'view') {
      onView(row);
    }
    if (option === 'edit') {
      onEdit(row);
    }
    if (option === 'delete') {
      onDelete(row);
    }
    if (option === 'resetDates') {
      onResetDates(row);
    }
  };

  return (
    <>
      <ButtonGroup
        variant="outlined"
        size="small"
        ref={anchorRef}
        aria-label="split button"
        sx={{
          '& .MuiButtonGroup-grouped:not(:last-of-type)': {
            borderRight: 'none',
          },
        }}
      >
        <Button
          startIcon={<TimelineRoundedIcon />}
          size="small"
          onClick={() => handleMenuItemClick('view')}
          // disabled={
          //   !row?.data?.BasicEnergySavings ||
          //   !row?.data?.BasicEnergySavings?.BaselineEnergyUsage ||
          //   !row?.energySavings
          // }
          sx={{
            width: 75,
            borderColor: 'divider',
            ':hover': { borderColor: 'divider' },
          }}
        >
          {t('button_labels.show_plot')}
        </Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
          sx={{
            borderColor: 'divider',
            ':hover': { borderColor: 'divider' },
          }}
        >
          <ArrowDropDownIcon fontSize="small" />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        modifiers={[
          {
            name: 'flip',
            options: { fallbackPlacements: ['top-start', 'bottom-start'] },
          },
          {
            name: 'preventOverflow',
            options: { altBoundary: true, rootBoundary: 'document' },
          },
        ]}
        style={{ zIndex: 1301 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              zIndex: 21302,
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  id="split-button-menu"
                  autoFocusItem
                  dense
                  sx={{ p: 1 }}
                >
                  <MenuItem
                    onClick={() => handleMenuItemClick('resetDates')}
                    sx={{
                      py: '6px',
                      px: '12px',
                      borderRadius: '5px',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <AutorenewRoundedIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" fontWeight="medium">
                        Nulstil perioder
                      </Typography>
                    </Box>
                  </MenuItem>
                  <Divider />
                  <MenuItem
                    onClick={() => handleMenuItemClick('edit')}
                    sx={{
                      py: '6px',
                      px: '12px',
                      borderRadius: '5px',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <EditRoundedIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" fontWeight="medium">
                        {t('button_labels.edit')}
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleMenuItemClick('delete')}
                    sx={{
                      py: '6px',
                      px: '12px',
                      borderRadius: '5px',
                      ':hover': { color: 'error.main' },
                      transition: 'color 0.2s ease-in-out',
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      <DeleteRoundedIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" fontWeight="medium">
                        {t('button_labels.delete')}
                      </Typography>
                    </Box>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
